import { render, staticRenderFns } from "./TheProtocolPreface.vue?vue&type=template&id=efbff962"
import script from "./TheProtocolPreface.vue?vue&type=script&lang=js"
export * from "./TheProtocolPreface.vue?vue&type=script&lang=js"
import style0 from "./TheProtocolPreface.vue?vue&type=style&index=0&id=efbff962&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports